(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

class HelpDisclosure extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.list = this.querySelector('.disclosure__list-wrapper');

    this.button.addEventListener('click', this.toggle.bind(this));
    document.addEventListener('click', this.closeOnClickOutside.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  toggle(event) {
    event.stopPropagation();
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close() : this.open();
  }

  open() {
    this.list.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    // uniquement sur mobile
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    this.list.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  closeOnClickOutside(event) {
    if (!this.contains(event.target)) this.close();
  }
}

customElements.define('help-disclosure', HelpDisclosure);

function closeOpenDisclosuresOnScroll() {
  document.querySelectorAll('.disclosure__list-wrapper').forEach((wrapper) => {
    if (!wrapper.hidden) {
      wrapper.hidden = true;
      const trigger = wrapper.previousElementSibling;
      if (trigger && trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });
}

window.addEventListener('scroll', closeOpenDisclosuresOnScroll, { passive: true });

/* RECHERCHES RÉCENTES DANS LA RECHERCHE DAWN */
(() => {
  const STORAGE_KEY = 'mangaref_recent_searches';
  const MAX_SEARCHES = 5;

  const predictiveSearch = document.querySelector(
    '.header-search-center predictive-search'
  );

  if (!predictiveSearch) return;

  const input = predictiveSearch.querySelector('#Search-In-Header');
  const form = predictiveSearch.querySelector('form');
  const results = predictiveSearch.querySelector('[data-predictive-search]');

  if (!input || !form || !results) return;


  function getRecentSearches() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(saved) ? saved : [];
    } catch {
      return [];
    }
  }


  function setRecentSearches(searches) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(searches)
      );
    } catch {}
  }


  function saveSearch(term) {
    term = term.trim();

    if (!term) return;

    let searches = getRecentSearches();

    searches = searches.filter(
      (search) =>
        search.toLocaleLowerCase() !==
        term.toLocaleLowerCase()
    );

    searches.unshift(term);

    setRecentSearches(
      searches.slice(0, MAX_SEARCHES)
    );
  }


  function openPredictiveSearch() {
    if (typeof predictiveSearch.open === 'function') {
      predictiveSearch.open();
    } else {
      predictiveSearch.setAttribute('open', '');
      input.setAttribute('aria-expanded', 'true');
    }
  }


  function showRecentSearches() {
    if (input.value.trim() !== '') return;

    const searches = getRecentSearches();

    results.innerHTML = '';

    const container = document.createElement('div');
    container.id = 'predictive-search-results';
    container.setAttribute('role', 'listbox');
    container.setAttribute('data-recent-searches', '');


    /* TITRE */
    const header = document.createElement('div');
    header.className = 'predictive-search__recent-header';

    const title = document.createElement('h2');
    title.className =
      'predictive-search__heading text-body caption-with-letter-spacing';

    title.textContent = 'Recherches récentes';

    header.appendChild(title);


    /* TOUT EFFACER */
    if (searches.length > 0) {
      const clear = document.createElement('button');

      clear.type = 'button';
      clear.className = 'predictive-search__recent-clear';
      clear.textContent = 'Tout effacer';

      clear.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        localStorage.removeItem(STORAGE_KEY);

        showRecentSearches();
        input.focus();
      });

      header.appendChild(clear);
    }

    container.appendChild(header);


    /* AUCUNE RECHERCHE */
    if (searches.length === 0) {
      const empty = document.createElement('p');

      empty.className = 'predictive-search__recent-empty';
      empty.textContent = 'Aucune recherche récente';

      container.appendChild(empty);
    }


    /* LISTE */
    if (searches.length > 0) {
      const list = document.createElement('ul');

      list.className =
        'predictive-search__results-list list-unstyled';

      list.setAttribute('role', 'group');


      searches.forEach((term) => {
        const item = document.createElement('li');

        item.className = 'predictive-search__list-item';


        const row = document.createElement('div');
        row.className = 'predictive-search__recent-row';


        /* Recherche */
        const searchButton = document.createElement('button');

        searchButton.type = 'button';

        searchButton.className =
          'predictive-search__item predictive-search__recent-term link link--text';

        searchButton.textContent = term;


        searchButton.addEventListener('click', () => {
          input.value = term;

          saveSearch(term);

          form.requestSubmit();
        });


        /* X */
        const removeButton = document.createElement('button');

        removeButton.type = 'button';
        removeButton.className =
          'predictive-search__recent-remove';

        removeButton.innerHTML = '&times;';

        removeButton.setAttribute(
          'aria-label',
          `Supprimer ${term}`
        );


        removeButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const updated = getRecentSearches().filter(
            (search) => search !== term
          );

          setRecentSearches(updated);

          showRecentSearches();
          input.focus();
        });


        row.appendChild(searchButton);
        row.appendChild(removeButton);

        item.appendChild(row);
        list.appendChild(item);
      });


      container.appendChild(list);
    }


    results.appendChild(container);

    openPredictiveSearch();
  }


  /* CLIC DANS LA BARRE VIDE */
  input.addEventListener('focus', () => {
    if (input.value.trim() === '') {
      showRecentSearches();
    }
  });


  /*
    DÈS QU'ON ÉCRIT :
    on retire seulement notre historique.
    Dawn fait ensuite sa recherche normalement.
  */
  input.addEventListener('input', () => {
    if (input.value.trim() === '') {
      showRecentSearches();
      return;
    }

    const recent = results.querySelector(
      '[data-recent-searches]'
    );

    if (recent) {
      recent.remove();
    }
  });


  /* RECHERCHE VALIDÉE */
  form.addEventListener('submit', () => {
    saveSearch(input.value);
  });


  /* CLIC SUR UN RÉSULTAT/SUGGESTION DAWN */
  predictiveSearch.addEventListener('click', (event) => {
    const item = event.target.closest(
      '#predictive-search-results:not([data-recent-searches]) .predictive-search__item'
    );

    if (!item) return;

    saveSearch(input.value);
  });


  /* CROIX NATIVE DE LA BARRE */
  form.addEventListener('reset', () => {
    setTimeout(() => {
      showRecentSearches();
    }, 0);
  });
})();

/* FERMETURE RECHERCHE MOBILE QUAND ON QUITTE LE CHAMP */
document.addEventListener('pointerdown', (event) => {
  if (!window.matchMedia('(max-width: 989px)').matches) return;

  const predictiveSearch = document.querySelector(
    '.header-search-center predictive-search'
  );

  if (!predictiveSearch || !predictiveSearch.hasAttribute('open')) return;

  const input = predictiveSearch.querySelector('#Search-In-Header');

  if (!input) return;

  /* Si on touche directement la barre de recherche :
     on ne ferme rien */
  if (event.target === input || event.target.closest('.field')) {
    return;
  }

  /* On laisse fonctionner normalement :
     - une recherche récente
     - son bouton X
     - Tout effacer
     - les résultats/suggestions Dawn
  */
  if (
    event.target.closest('.predictive-search__recent-term') ||
    event.target.closest('.predictive-search__recent-remove') ||
    event.target.closest('.predictive-search__recent-clear') ||
    event.target.closest('#predictive-search-results:not([data-recent-searches]) .predictive-search__item')
  ) {
    return;
  }

  /* Partout ailleurs = on quitte réellement la recherche */
  input.blur();

  if (typeof predictiveSearch.close === 'function') {
    predictiveSearch.close();
  } else {
    predictiveSearch.removeAttribute('open');
    input.setAttribute('aria-expanded', 'false');
  }
});

/* FERME LA RECHERCHE MOBILE QUAND LE CLAVIER EST VALIDÉ / FERMÉ */
const mobileSearchInput = document.querySelector('#Search-In-Header');

if (mobileSearchInput) {
  mobileSearchInput.addEventListener('blur', () => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;

    setTimeout(() => {
      const predictiveSearch = document.querySelector(
        '.header-search-center predictive-search'
      );

      if (!predictiveSearch || !predictiveSearch.hasAttribute('open')) return;

      const activeElement = document.activeElement;

      /* Si le focus est passé sur un élément utile de la recherche,
         on garde la fenêtre ouverte */
      if (
        activeElement &&
        (
          activeElement.closest?.('.predictive-search__recent-term') ||
          activeElement.closest?.('.predictive-search__recent-remove') ||
          activeElement.closest?.('.predictive-search__recent-clear') ||
          activeElement.closest?.('.predictive-search__item')
        )
      ) {
        return;
      }

      if (typeof predictiveSearch.close === 'function') {
        predictiveSearch.close();
      } else {
        predictiveSearch.removeAttribute('open');
        mobileSearchInput.setAttribute('aria-expanded', 'false');
      }
    }, 100);
  });
}


  } catch(e) { console.error(e); }
})();
})();
